import type { Plan } from '../types';

// Libellé d'affichage du plan d'abonnement (badge profil, ligne « Mon offre »).
export const PLAN_LABEL: Record<Plan, string> = {
  free: 'Free',
  plus: 'Plus',
  pro: 'Pro',
  school: 'École',
};
